export default "__VITE_ASSET__Cx0wWlkr__"